import { useEffect, useState } from "react";
import { Mail } from "lucide-react";
import { toast } from "sonner";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { useProducts } from "../../context/ProductsContext";
import { updateSettings } from "../../lib/api";

/*
  Admin → Settings tab. The contact email is shown in the site footer and is where
  new-order and inquiry notifications are sent (PUT /api/settings).
*/
export default function SettingsAdmin({ onUnauthorized }) {
  const { settings, setSettings } = useProducts();
  const [email, setEmail] = useState(settings.contact_email || "");
  const [saving, setSaving] = useState(false);

  useEffect(() => setEmail(settings.contact_email || ""), [settings.contact_email]);

  const save = async (e) => {
    e.preventDefault();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim())) {
      toast.error("Enter a valid email address.");
      return;
    }
    setSaving(true);
    try {
      const saved = await updateSettings({ contact_email: email.trim() });
      setSettings(saved);
      toast.success("Contact email saved.");
    } catch (err) {
      if (err.message === "unauthorized") onUnauthorized && onUnauthorized();
      else toast.error(err.message || "Could not save.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <form onSubmit={save} data-testid="admin-settings" className="bg-white rounded-2xl border border-[#EFE9E0] p-6 max-w-lg">
      <Label htmlFor="s-email" className="flex items-center gap-1.5">
        <Mail size={14} /> Bakery contact email
      </Label>
      <p className="text-xs text-[#787069] mt-1">
        Shown in the site footer. New orders and inquiries are emailed here.
      </p>
      <Input id="s-email" data-testid="settings-email" type="email" value={email}
        onChange={(e) => setEmail(e.target.value)} className="mt-3 h-11 bg-cream" />
      <Button type="submit" data-testid="settings-save" disabled={saving || email.trim() === settings.contact_email}
        className="mt-4 rounded-full bg-olive hover:bg-olive-hover text-cream">
        {saving ? "Saving…" : "Save"}
      </Button>
    </form>
  );
}
